/* eslint-disable react/prop-types */
import MDInput from "components/MDInput";
import { IMaskMixin } from "react-imask";

export const PhoneMaskInput = IMaskMixin(({ inputRef, ...props }) => (
  <MDInput inputRef={inputRef} {...props} />
));
export default PhoneMaskInput;
